angular.module('admin.directives')

.directive('userHomesList', ['UserService', 'UserHomesService', function(UserService, UserHomesService){
  return {
    restrict: 'EA',
    controllerAs: 'userHomesListCtrl',
    bindToController: {
      agentId: '=',
      userId: '=',
      showSharedToggle: '=?'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/user-homes-list.html',

    controller: function(){
      let ctrl = this;

      ctrl.refresh = () => {
        UserService.getUserHomes(ctrl.userId)
          .then((homes) => {
            ctrl.loading = false;
            ctrl.homes = homes;
          })
          .catch((err) => {
            ctrl.error = err;
          });
      };

      ctrl.toggle = (currentStatus, userHomeId) => {
        const shouldEnable = ['disabled', 'forceDisabled'].includes(currentStatus);

        function updateDigestStatusAndRefresh(digestStatus) {
          UserHomesService.updateDigestStatus(userHomeId, digestStatus)
            .then(function() {
              ctrl.refresh();
            });
        }

        if(shouldEnable) {
          if(confirm('Are you sure you want to enable the duplicate digest?')) {
            ctrl.loading = true;
            updateDigestStatusAndRefresh('forceEnabled');
          }
        } else {
          ctrl.loading = true;
          updateDigestStatusAndRefresh('forceDisabled');
        }
      };

      ctrl.refresh();
    }

  }

}]);
